import { Fade } from '@mui/material';
import type { RefObject } from 'react';

import Icon, { IconName } from '@/components/Icon/Icon';
import { brandColors } from '@/styles/theme/values/brandColors';

import useStyles from './InputErrorText.styles';

const InputErrorText = ({
  errorMessage,
  errorId,
  errorMessageRef,
}: {
  errorMessage: string | undefined;
  errorId?: string;
  errorMessageRef?: RefObject<HTMLSpanElement | null>;
}) => {
  const { classes } = useStyles();

  if (!errorMessage) return null;

  const hasError = !!errorMessage;
  return (
    <Fade in={hasError} timeout={hasError ? 500 : 200}>
      <div className={classes.error}>
        <Icon
          name={IconName.WARNING}
          fontSize={24}
          color={brandColors.errorMain}
          data-testid='error-icon'
        />
        <span
          role={hasError ? 'alert' : 'none'}
          id={errorId}
          ref={errorMessageRef}
        >
          {errorMessage}
        </span>
      </div>
    </Fade>
  );
};

export default InputErrorText;
